"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _urlJoin = _interopRequireDefault(require("url-join"));

var _config = require("../utils/config");

var _ = require("./");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var STORED_PROPS = {
  PAGE_SIZE: 'PAGE_SIZE',
  SORT_ORDER: 'SORT_ORDER',
  SELECTED_ROWS: 'SELECTED_ROWS'
};

var DataTableWithToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(DataTableWithToolbar, _React$Component);

  var _super = _createSuper(DataTableWithToolbar);

  function DataTableWithToolbar(props) {
    var _props$onSortedChange;

    var _this;

    _classCallCheck(this, DataTableWithToolbar);

    _this = _super.call(this, props);
    var pageSize = 20;
    var sorted = props.config.defaultSorted || [];
    var selectedTableRows = []; // Read initial config settings from session storage, if enabled:

    if (_this.props.sessionStorage) {
      var storedSorted = JSON.parse(window.sessionStorage.getItem(_this.getStorageKey(STORED_PROPS.SORT_ORDER)));
      var storedPageSize = JSON.parse(window.sessionStorage.getItem(_this.getStorageKey(STORED_PROPS.PAGE_SIZE)));
      var storedSelectedRows = JSON.parse(window.sessionStorage.getItem(_this.getStorageKey(STORED_PROPS.SELECTED_ROWS)));

      if (storedSorted) {
        sorted = storedSorted;
        _this.props.config.defaultSorted = sorted;
      }

      if (storedPageSize) {
        pageSize = storedPageSize;
      }

      if (storedSelectedRows && storedSelectedRows.length) {
        selectedTableRows = storedSelectedRows;
      }
    }

    _this.state = {
      pageSize: pageSize,
      sorted: sorted,
      selectedTableRows: selectedTableRows
    };
    (_props$onSortedChange = props.onSortedChange) === null || _props$onSortedChange === void 0 ? void 0 : _props$onSortedChange.call(props, sorted);
    return _this;
  }

  _createClass(DataTableWithToolbar, [{
    key: "getStorageKey",
    value: function getStorageKey(prop) {
      switch (prop) {
        case STORED_PROPS.PAGE_SIZE:
          return "arranger-table-pagesize-".concat(this.props.storageKey || '');

        case STORED_PROPS.SORT_ORDER:
          return "arranger-table-sorted-".concat(this.props.storageKey || '');

        case STORED_PROPS.SELECTED_ROWS:
          return "arranger-table-selectedrows-".concat(this.props.storageKey || '');

        default:
          return '';
      }
    }
  }, {
    key: "storeProperty",
    value: function storeProperty(prop, value) {
      if (this.props.sessionStorage) {
        var stringValue = JSON.stringify(value);
        window.sessionStorage.setItem(this.getStorageKey(prop), stringValue);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(nextProps.sqon, this.props.sqon)) {
        this.setState({
          page: 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$allowTogg = _this$props.allowTogglingColumns,
          allowTogglingColumns = _this$props$allowTogg === void 0 ? true : _this$props$allowTogg,
          _this$props$allowTSVE = _this$props.allowTSVExport,
          allowTSVExport = _this$props$allowTSVE === void 0 ? true : _this$props$allowTSVE,
          _this$props$alwaysSor = _this$props.alwaysSorted,
          alwaysSorted = _this$props$alwaysSor === void 0 ? [] : _this$props$alwaysSor,
          columnDropdownText = _this$props.columnDropdownText,
          config = _this$props.config,
          _this$props$customAct = _this$props.customActions,
          customActions = _this$props$customAct === void 0 ? null : _this$props$customAct,
          _this$props$customHea = _this$props.customHeaderContent,
          customHeaderContent = _this$props$customHea === void 0 ? null : _this$props$customHea,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? null : _this$props$data,
          _this$props$downloadU = _this$props.downloadUrl,
          downloadUrl = _this$props$downloadU === void 0 ? '' : _this$props$downloadU,
          _this$props$enableDro = _this$props.enableDropDownControls,
          enableDropDownControls = _this$props$enableDro === void 0 ? false : _this$props$enableDro,
          enableSelectedTableRowsExporterFilter = _this$props.enableSelectedTableRowsExporterFilter,
          selectedRowsFilterPropertyName = _this$props.selectedRowsFilterPropertyName,
          exporter = _this$props.exporter,
          exporterLabel = _this$props.exporterLabel,
          exportTSVFilename = _this$props.exportTSVFilename,
          exportTSVText = _this$props.exportTSVText,
          fetchData = _this$props.fetchData,
          filterInputPlaceholder = _this$props.filterInputPlaceholder,
          initalSelectedTableRows = _this$props.initalSelectedTableRows,
          InputComponent = _this$props.InputComponent,
          _this$props$keepSelec = _this$props.keepSelectedOnPageChange,
          keepSelectedOnPageChange = _this$props$keepSelec === void 0 ? false : _this$props$keepSelec,
          _this$props$loading = _this$props.loading,
          loading = _this$props$loading === void 0 ? null : _this$props$loading,
          maxPagesOptions = _this$props.maxPagesOptions,
          _this$props$onColumns = _this$props.onColumnsChange,
          onColumnsChange = _this$props$onColumns === void 0 ? function () {} : _this$props$onColumns,
          _this$props$onFilterC = _this$props.onFilterChange,
          onFilterChange = _this$props$onFilterC === void 0 ? function () {} : _this$props$onFilterC,
          _this$props$onMultipl = _this$props.onMultipleColumnsChange,
          onMultipleColumnsChange = _this$props$onMultipl === void 0 ? function () {} : _this$props$onMultipl,
          _this$props$onSortedC = _this$props.onSortedChange,
          _onSortedChange = _this$props$onSortedC === void 0 ? function () {} : _this$props$onSortedC,
          _this$props$projectId = _this$props.projectId,
          projectId = _this$props$projectId === void 0 ? _config.PROJECT_ID : _this$props$projectId,
          sessionStorage = _this$props.sessionStorage,
          _this$props$selectedT = _this$props.selectedTableRows,
          selectedTableRows = _this$props$selectedT === void 0 ? [] : _this$props$selectedT,
          _this$props$setSelect = _this$props.setSelectedTableRows,
          _setSelectedTableRows = _this$props$setSelect === void 0 ? function () {} : _this$props$setSelect,
          _this$props$showFilte = _this$props.showFilterInput,
          showFilterInput = _this$props$showFilte === void 0 ? true : _this$props$showFilte,
          sqon = _this$props.sqon,
          tableStyle = _this$props.tableStyle,
          toolbarStyle = _this$props.toolbarStyle,
          transformParams = _this$props.transformParams;

      var _this$state = this.state,
          page = _this$state.page,
          pageSize = _this$state.pageSize,
          sorted = _this$state.sorted,
          total = _this$state.total;
      var url = downloadUrl || (0, _urlJoin["default"])(_config.ARRANGER_API, projectId, 'download');
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.TableToolbar, {
        allColumns: config.allColumns,
        allowTSVExport: allowTSVExport,
        allowTogglingColumns: allowTogglingColumns,
        columnDropdownText: columnDropdownText,
        columns: config.columns,
        customActions: customActions,
        customHeaderContent: customHeaderContent,
        defaultColumns: config.defaultColumns,
        downloadUrl: url,
        enableDropDownControls: enableDropDownControls,
        enableSelectedTableRowsExporterFilter: enableSelectedTableRowsExporterFilter,
        selectedRowsFilterPropertyName: selectedRowsFilterPropertyName,
        exportTSVFilename: exportTSVFilename,
        exportTSVText: exportTSVText,
        exporter: exporter,
        exporterLabel: exporterLabel,
        filterInputPlaceholder: filterInputPlaceholder,
        InputComponent: InputComponent,
        keyField: config.keyField,
        onColumnsChange: onColumnsChange,
        onFilterChange: onFilterChange,
        onMultipleColumnsChange: onMultipleColumnsChange,
        page: page,
        pageSize: pageSize,
        propsData: data,
        selectedTableRows: selectedTableRows,
        showFilterInput: showFilterInput,
        sqon: sqon,
        style: toolbarStyle,
        total: total,
        transformParams: transformParams,
        type: config.type
      }), /*#__PURE__*/_react["default"].createElement(_.Table, {
        style: tableStyle,
        propsData: data,
        sqon: sqon,
        config: config,
        fetchData: fetchData,
        setSelectedTableRows: function setSelectedTableRows(selectedTableRows) {
          _setSelectedTableRows(selectedTableRows);

          _this2.storeProperty(STORED_PROPS.SELECTED_ROWS, selectedTableRows);
        },
        onPaginationChange: function onPaginationChange(state) {
          _this2.setState(state);

          if (state.pageSize) {
            _this2.storeProperty(STORED_PROPS.PAGE_SIZE, state.pageSize);
          }
        },
        onSortedChange: function onSortedChange(sorted) {
          _this2.setState({
            sorted: sorted,
            page: 0
          });

          _onSortedChange(sorted);

          _this2.storeProperty(STORED_PROPS.SORT_ORDER, sorted);
        },
        defaultPageSize: pageSize,
        defaultSorted: sorted,
        sorted: sorted,
        loading: loading,
        maxPagesOptions: maxPagesOptions,
        alwaysSorted: alwaysSorted,
        initalSelectedTableRows: initalSelectedTableRows || this.state.selectedTableRows,
        keepSelectedOnPageChange: sessionStorage || keepSelectedOnPageChange // If false, this will reset the selection to empty on reload. To keep selections after reload set this to true. Use sessionStorage or specific property to set this.
        ,
        selectedTableRows: selectedTableRows
      }));
    }
  }]);

  return DataTableWithToolbar;
}(_react["default"].Component);

var _default = DataTableWithToolbar;
exports["default"] = _default;